import { SettingParentContext } from "global/cnr/contexts/SettingParentContext";
import { SettingsAreaContext } from "global/cnr/contexts/SettingsAreaContext";
import { ViewSettingsContext } from "global/cnr/contexts/ViewSettingsContext";
import { getFormPropz } from "global/components/forms/props/formPropz";
import { gEnums } from "global/enums/globalEnums";
import { useContext, useMemo } from "react";
import { _swipeComponentTypes, _swipeContentTypes } from "../ViewSettingsComponent";
import { vsComponentTypes } from "../enums/vsComponentTypes";
import { getTempSettingsState } from "global/firestoreData/settings/ammendSettings";
import { isBefore } from "date-fns";
import { reduceObject } from "global/common/sorting";
import { useTempSettings } from "global/cnr/contexts/useHelpers/useTempSettings";

export const useSwipeComponentType = (swipedItem, { questionProps, preview, formHandler, handlers }) => {
  return useMemo(() => {
    const { key, subKey, vit, dKey, diKey, helpKey } = swipedItem ?? {};

    if (questionProps) return _swipeComponentTypes.confirmationQuestion;
    if (preview) return _swipeComponentTypes.jsonPreview;

    if (vit) {
      return _swipeComponentTypes.settingsContentWithWrap_vit;
    } else if (dKey && diKey) {
      return _swipeComponentTypes.settingsFormPage_d;
    } else if (helpKey) {
      return _swipeComponentTypes.helpPage;
    }

    if (subKey) {
      switch (key) {
        case vsComponentTypes.files:
          return _swipeComponentTypes.filesPage;
        default:
          return _swipeComponentTypes.subContent;
      }
    }

    switch (key) {
      case vsComponentTypes.add:
        return _swipeComponentTypes.createSettingsPage;

      case vsComponentTypes.createClient:
      case vsComponentTypes.createEvent:
      case vsComponentTypes.updateEvent:
        return _swipeComponentTypes.createSomething;

      case vsComponentTypes.deleteClient:
        return _swipeComponentTypes.deleteClientPage;

      case vsComponentTypes.deleteEvent:
        return _swipeComponentTypes.deleteEventPage;

      case vsComponentTypes.uploadImage:
        return _swipeComponentTypes.uploadPage;

      case vsComponentTypes.dataCollections:
      case vsComponentTypes.dataLists:
        return _swipeComponentTypes.dataListPage;

      case vsComponentTypes.forms:
        return _swipeComponentTypes.formListPage;

      case vsComponentTypes.filePicker:
        return _swipeComponentTypes.filePickerPage;

      case vsComponentTypes.manifestPicker:
        return _swipeComponentTypes.manifestPickerPage;

      default:
        if (formHandler) {
          const {
            allowSettingsUpdate,
            settingsUpdateHandler,
            settingsUpdateHandlerFunction,
          } = formHandler ?? {};
          const handler = handlers ? handlers[settingsUpdateHandler] : {};
          const handlerFn = handler
            ? handler[settingsUpdateHandlerFunction]
            : {};
          if (allowSettingsUpdate && handlerFn) {
            return _swipeComponentTypes.settingsContentWithWrap_fhau;
          }
          return _swipeComponentTypes.settingsContentWithWrap_fh;
        }
        return _swipeComponentTypes.settingsContentWithWrap;
    }
  }, [swipedItem, questionProps, preview, formHandler, handlers]);
};

export const getSettingsContentType = (swipedItem, { isMulti }) => {

  const _vsts = gEnums.viewSettingTypes

  switch (swipedItem?.key) {
    case _vsts.dataFilters:
      return _swipeContentTypes.dataFilters;

    case _vsts.appData:
    case _vsts.globalPageItems:
    case _vsts.props:
    case _vsts.propSection:
    case _vsts.propSections:
    case _vsts.viewItems:
    case _vsts.views:
    case _vsts.dashboard:
      return _swipeContentTypes.settingsMenuContainer_wrap;

    case _vsts.appActions:
    case _vsts.googleActions:
    case _vsts.productionActions:
    case _vsts.settingsActions:
    case _vsts.baseSettings:
    case _vsts.viewActions:
      return _swipeContentTypes.settingsActionItems;

    case _vsts.appAccessRequests:
      return _swipeContentTypes.appAccessRequests;

    case _vsts.appUserSignInEmails:
      return _swipeContentTypes.appUserSignInEmails;

    case vsComponentTypes.notificationsManager:
      return _swipeContentTypes.notificationsManager;

    case _vsts.json:
      return _swipeContentTypes.jsonViewer;

    case _vsts.propOrganize:
      return _swipeContentTypes.propOrganizeGrid;

    case _vsts.raw:
      return _swipeContentTypes.tabbedDataView;

    case vsComponentTypes.constraintBuilder:
      return _swipeContentTypes.constraintBuilder;

    case vsComponentTypes.card:
      return _swipeContentTypes.cardSettings;

    default:
      return isMulti
        ? _swipeContentTypes.settingsMenuContainer_wrap_multi
        : _swipeContentTypes.settingsFormPage;
  }
};


export const useSwipeProps = (
  data_current,
  swipedItem,
  updateProps,
  isGlobal,
  appArea,
  callOrigin
) => {

  const settingsParentContext = useContext(SettingParentContext)
  const { states } = settingsParentContext ?? {}
  const { currentSettings_state } = states ?? {}
  const { aps_global, aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {});

  const _aps_global = _.cloneDeep(aps_global);
  const _aps_viewItems = _.cloneDeep(aps_viewItems);

  const _currSettings = {
    global: _aps_global,
    viewItems: _aps_viewItems
  }

  const viewItems_parent = isGlobal ? _aps_global : _aps_viewItems

  // settingsAreaContext
  const settingsAreaContext = useContext(SettingsAreaContext);
  const { settingsArea_fns } = settingsAreaContext ?? {}

  // viewSettingsContext - this will NOT be there if coming forom App Settings
  const viewSettingsContext = useContext(ViewSettingsContext)
  const { viewSettings_state, viewSettings_handlers } = viewSettingsContext ?? {}
  const { settings_temp } = viewSettings_state ?? {}

  const { _viewItems } = useTempSettings(settings_temp, isGlobal)
  //  
  const _view_items = _viewItems || viewItems_parent

  const swipeProps = {
    key: swipedItem ? swipedItem.key : null,
    viewProps: null,
    isMulti: false,
    swipedItem,
  };

  if (swipedItem) {
    getSelectedSettingsGroupItem(
      swipeProps,
      updateProps,
      _.cloneDeep(_view_items),
      data_current,
      settingsArea_fns,
      isGlobal,
      appArea,
      callOrigin,
      _currSettings
    );
  }

  if (swipedItem) {
    const udp = updateProps
      ? updateProps
      : {
        formKey: swipedItem.key,
        parentSettingKey: swipedItem.parentSettingKey,
        subKey: swipedItem.subKey,
      };

    const fpp = {
      data_init: data_current,
      form_handlers: viewSettings_handlers,
      formActions: swipeProps.formActions,
      formHandler: swipeProps.formHandler,
      updateProps: udp,
      viewProps: swipeProps.viewProps,
      viewPropsAllowed: swipeProps.viewPropsAllowed,
    };

    swipeProps.formProps = getFormPropz(fpp);
  }

  return swipeProps;
};

/**
 *  
 * @param {object} data_current 
 * @param {handlers} viewSettings_handlers 
 * @param {object} swipedItem 
 * @param {object} updateProps 
 * @param {object} viewItems 
 * @returns the swipeProp settings (viewProps, formProps) for the swipedItem
 */
export const getSwipeProps = (data_current, viewSettings_handlers, swipedItem, updateProps, viewItems, settingsArea_fns, isGlobal, appArea) => {

  const swipeProps = {
    key: swipedItem ? swipedItem.key : null,
    viewProps: null,
    isMulti: false,
    swipedItem,
  }

  if (swipedItem) { getSelectedSettingsGroupItem(swipeProps, updateProps, viewItems, data_current, settingsArea_fns, isGlobal, appArea) }

  if (swipedItem) {
    const udp = updateProps ? updateProps : { formKey: swipedItem.key, parentSettingKey: swipedItem.parentSettingKey, subKey: swipedItem.subKey }

    const fpp = {
      form_handlers: viewSettings_handlers,
      updateProps: udp,
      viewProps: swipeProps.viewProps,
      viewPropsAllowed: swipeProps.viewPropsAllowed,
      data_init: data_current,
      formActions: swipeProps.formActions,
      formHandler: swipeProps.formHandler,
    }
    swipeProps.formProps = getFormPropz(fpp)
  }

  return swipeProps

}

/**
 * IMPORTANT: Settings - View Props get the viewProps from the selected item
 * Ammends the swipeProps
 * @param {object} swipeProps (swipedItem) swipedItem:(dataListKey, dKey, subKey, vit, pit, psg, key)
 * @param {object} updateProps 
 * @param {object} viewItems 
 * @param {object} data_current 
 * @returns the settings groupItems (viewProps and buttons) for the swipedItem
 */
const getSelectedSettingsGroupItem = (swipeProps, updateProps, viewItems, data_current, settingsArea_fns, isGlobal, appArea, callOrigin, currSettings) => {

  const { getSelectedGroupItem, getSettingsBaseItem, ammendDataGroupItem } = settingsArea_fns ?? {}

  const { swipedItem } = swipeProps ?? {}
  const { dKey, subKey } = swipedItem ?? {}

  let selectedGroupItem;

  if (dKey && viewItems) {
    swipeProps.viewProps = viewItems
  } else {
    // determine what viewItems by the 'key' of the swipeProps.
    switch (swipeProps.key) {
      case gEnums.viewSettingTypes.globalPageItems:
      case gEnums.viewSettingTypes.propSections:
      case gEnums.viewSettingTypes.viewItems:
      case gEnums.viewSettingTypes.views:
        swipeProps.viewProps = viewItems
        break;

      default:
        if (swipedItem.vit || swipedItem.pit || swipedItem.psg) {
          selectedGroupItem = getSelectedGroupItem(swipedItem, isGlobal)
          swipeProps.isMulti = true
        } else {
          //   swipedItem, updateProps, swipeProps, isGlobal_app, callOrigin, currSettings
          selectedGroupItem = ammendDataGroupItem(swipedItem, updateProps, swipeProps, isGlobal, callOrigin, currSettings)
        }

        if (selectedGroupItem) {

          const {
            childItems, // the list of child item. Each child item will be renderd to the childMenuItem OR card, description, list, mete
            childItemsFromData,
            childMenuItem, // the menuItem from which the childItems will be rendered
            childMenuItems, // {card, description, list, mete}
            extraMenuItems,
            formActions,
            groupItems,
            isStatic,
            restrictedAccess,
            formHandler,
          } = selectedGroupItem

          console.log('selectedGroupItem', selectedGroupItem)

          if (isStatic) { swipeProps.isStatic = true }

          if (childItemsFromData && !subKey) {
            // get the list from data instead of a static list.
            const dks = Object.keys(data_current)
            swipeProps.viewProps = dks
            swipeProps.isMulti = true
          } else if (childItems && !subKey) {
            swipeProps.viewProps = childItems
            swipeProps.isMulti = true
          } else {
            // SET THE VIEW PROPS

            if (subKey) {
              swipeProps.viewProps = getSettingsBaseItem(subKey)
            } else if (!groupItems && childItems && childItems.length > 0 && subKey) {
              swipeProps.viewProps = getSettingsBaseItem(subKey)
            } else {
              swipeProps.viewProps = _.cloneDeep(groupItems) // ammendComponents(groupItems, isGlobal, appArea)
            }

            if (swipeProps.viewProps) {
              try {
                swipeProps.viewProps = reduceObject(swipeProps.viewProps, 'hideFromMenu')
              } catch (error) {
                console.log('swipeProps: error', swipeProps)
                console.error('swipeProps.viewProps: error', error)
              }
            }

            // only the viewProps that are not marked with hideFromMenu  
            if (childMenuItem || childMenuItems) {

              const cmi = childMenuItem ? childMenuItem : childMenuItems[swipedItem.subKey]

              const _childMenuItems = getSettingsBaseItem(cmi)
              const allowedItems = getSettingsBaseItem(cmi, 'allowedItems')

              if (_childMenuItems && allowedItems && allowedItems[subKey]) {
                const cmis = {}
                const allowed = allowedItems[subKey]
                allowed.forEach(ai => {
                  if (_childMenuItems[ai]) { cmis[ai] = _childMenuItems[ai] }
                })
                let capped = false
                if (cmis && Object.keys(cmis).length > 0) {
                  try {
                    Object.keys(cmis).forEach(k => {
                      if (!cmis[k] && !cmis[k].data && !cmis[k].data.breakBefore && !capped) {
                        cmis[k].data.breakBefore = 'Additional'
                        capped = true
                      }
                    })
                  } catch (error) {
                    console.log('error', error)
                  }

                }
                swipeProps.viewProps = cmis
              } else {
                swipeProps.viewProps = _childMenuItems
              }
            }

            if (extraMenuItems) {
              const emi = extraMenuItems[swipedItem.subKey]
              const extraItems = getSettingsBaseItem(emi)
              if (extraItems) {
                const existingCount = swipeProps.viewProps ? Object.keys(swipeProps.viewProps).length : 0
                Object.keys(extraItems).forEach(eiKey => {
                  extraItems[eiKey]._position = extraItems[eiKey]._position + (existingCount - 1)
                })
                const fei = _.find(extraItems, { _position: existingCount - 1 })
                if (fei && fei.key) { extraItems[fei.key].data.breakBefore = 'Additional' }
                const merged = { ...swipeProps.viewProps, ...extraItems }
                swipeProps.viewProps = merged
              }
            }

            if (restrictedAccess && swipedItem.subKey && restrictedAccess[swipedItem.subKey]) {
              swipeProps.restrictedAccess = restrictedAccess[swipedItem.subKey]
            }
          }

          if (!swipeProps.viewProps) { swipeProps.isStatic = true }

          if (formHandler) { swipeProps.formHandler = formHandler }
          if (formActions) { swipeProps.formActions = formActions }

        }
    }
  }
} 